import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CampaignPagination = ({
  currentPage,
  totalPages,
  totalItems,
  perPage,
  onPageChange,
  loading = false,
}) => {
  const handlePrevious = () => {
    if (currentPage > 1 && !loading) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages && !loading) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage && !loading) {
      onPageChange(page);
    }
  };

  // Calculate page numbers to show
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      // Show all pages if total pages is less than max
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show pages around current page
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        startPage = 1;
        endPage = Math.min(5, totalPages);
      } else if (currentPage >= totalPages - 2) {
        startPage = Math.max(1, totalPages - 4);
        endPage = totalPages;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  if (totalPages <= 1) {
    return null; // Don't show pagination if only one page
  }

  const pageNumbers = getPageNumbers();
  const startItem = (currentPage - 1) * perPage + 1;
  const endItem = Math.min(currentPage * perPage, totalItems);

  return (
    <div className="camp-pager">
      <div className="camp-pager-info">
        Showing <b>{startItem}</b> to <b>{endItem}</b> of <b>{totalItems}</b> campaigns
      </div>
      <div className="camp-pager-btns">
        <button
          type="button"
          onClick={handlePrevious}
          disabled={currentPage === 1 || loading}
          className="ping-btn ping-btn-ghost ping-btn-sm"
          title="Previous page"
        >
          <ChevronLeft size={16} />
        </button>
        {pageNumbers[0] > 1 && (
          <>
            <button type="button" onClick={() => handlePageClick(1)} disabled={loading} className="ping-btn ping-btn-ghost ping-btn-sm">
              1
            </button>
            {pageNumbers[0] > 2 && <span className="camp-pager-ell">…</span>}
          </>
        )}
        {pageNumbers.map((page) => (
          <button
            key={page}
            type="button"
            onClick={() => handlePageClick(page)}
            disabled={loading}
            className={`ping-btn ping-btn-sm ${page === currentPage ? "ping-btn-primary" : "ping-btn-ghost"}`}
          >
            {page}
          </button>
        ))}
        {pageNumbers[pageNumbers.length - 1] < totalPages && (
          <>
            {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && <span className="camp-pager-ell">…</span>}
            <button type="button" onClick={() => handlePageClick(totalPages)} disabled={loading} className="ping-btn ping-btn-ghost ping-btn-sm">
              {totalPages}
            </button>
          </>
        )}
        <button
          type="button"
          onClick={handleNext}
          disabled={currentPage === totalPages || loading}
          className="ping-btn ping-btn-ghost ping-btn-sm"
          title="Next page"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default CampaignPagination;
